// Revenue produced by everyone below a rep (the rep's own figure excluded),
// summed down the tree for the given field: "projected_revenue" for the
// season projection, "total_revenue" for what is on the books so far.
export const downlineRevenue = (rep, field) =>
  (rep?.reps || []).reduce(
    (sum, child) =>
      sum + (parseFloat(child?.[field]) || 0) + downlineRevenue(child, field),
    0
  );
